import { Navigate } from "react-router-dom";
import { getUserFromToken } from "../services/authService";

export default function ProtectedRoute({ children, allowRoles = [] }) {
  const user = getUserFromToken();
  if (!user) return <Navigate to="/login" replace />;

  if (allowRoles.length && !allowRoles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
